import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { SharedModule } from '@app/shared/shared.module';
import { ButtonComponent } from '@app/shared/components/button/button.component';

@Component({
  selector: 'slotcom-login-error-modal',
  templateUrl: './login-error.component.html',
  styleUrls: ['./login-error.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule],
})
export class LoginErrorModalComponent {
  private eventManager = inject(EventManager);
  loginErrorModalData = inject<Modal>(MAT_DIALOG_DATA);

  platform: string;
  errorCode: number;

  constructor() {
    const loginErrorModalData = this.loginErrorModalData;

    this.platform = loginErrorModalData.data.platform;
    this.errorCode = loginErrorModalData.data.errorCode;
  }

  public closeDialog() {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.LoginErrorModalComponent, ModalType.View));
  }
}
